(function () {
  'use strict';
  var KEY = 'jp-wishlist-v1';
  function cleanText(value, maxLength) {
    return typeof value === 'string' ? value.trim().slice(0, maxLength) : '';
  }
  function cleanProductUrl(value) {
    if (typeof value !== 'string' || value.length > 500) return '';
    try {
      var url = new URL(value, window.location.origin);
      var productPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i;
      if (url.origin !== window.location.origin || !productPath.test(url.pathname)) return '';
      return url.pathname + url.search;
    } catch (e) { return ''; }
  }
  function cleanImageUrl(value) {
    if (typeof value !== 'string' || !value || value.length > 1000) return '';
    try {
      var url = new URL(value, window.location.origin);
      if (url.protocol !== 'https:') return '';
      var trustedShopifyHost = /(^|\.)shopify\.com$|(^|\.)shopifycdn\.net$/i.test(url.hostname);
      if (url.origin !== window.location.origin && !trustedShopifyHost) return '';
      return url.href;
    } catch (e) { return ''; }
  }
  function normalizeProduct(product) {
    if (!product || typeof product !== 'object') return null;
    var id = cleanText(String(product.id || ''), 30);
    var title = cleanText(product.title, 300);
    var url = cleanProductUrl(product.url);
    if (!/^[0-9]+$/.test(id) || !title || !url) return null;
    return {
      id: id,
      title: title,
      url: url,
      image: cleanImageUrl(product.image),
      vendor: cleanText(product.vendor, 120),
      price: cleanText(product.price, 100),
      compare: cleanText(product.compare, 100)
    };
  }
  function heartIcon() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M20.8 8.9c0 5.2-8.8 10.1-8.8 10.1S3.2 14.1 3.2 8.9A4.7 4.7 0 0 1 12 6.3a4.7 4.7 0 0 1 8.8 2.6Z');
    svg.appendChild(path); return svg;
  }
  function removeIcon() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M5 7h14M9 7V5h6v2m-8 0 1 13h8l1-13M10 11v5m4-5v5');
    svg.appendChild(path); return svg;
  }
  function read() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.map(normalizeProduct).filter(Boolean).slice(0, 100);
    } catch (e) { return []; }
  }
  function write(items) {
    try { window.localStorage.setItem(KEY, JSON.stringify(items.slice(0, 100))); } catch (e) {}
  }
  function sync(items) {
    var ids = items.map(function (p) { return String(p.id); });
    document.querySelectorAll('[data-jp-wishlist-button]').forEach(function (button) {
      var active = ids.indexOf(String(button.dataset.jpWishlistProductId)) !== -1;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', (active ? 'Remove ' : 'Add ') + (button.dataset.jpWishlistTitle || 'item') + ' ' + (active ? 'from' : 'to') + ' favorites');
    });
    document.querySelectorAll('[data-jp-wishlist-header]').forEach(function (header) {
      var active = items.length > 0;
      header.dataset.jpWishlistActive = String(active);
      header.setAttribute('aria-label', active ? 'View favorites, saved items' : 'View favorites');
    });
  }
  function toggle(button) {
    var items = read(), id = String(button.dataset.jpWishlistProductId);
    var exists = items.some(function (p) { return String(p.id) === id; });
    if (exists) items = items.filter(function (p) { return String(p.id) !== id; });
    else {
      var product = normalizeProduct({
        id: id,
        title: button.dataset.jpWishlistTitle,
        url: button.dataset.jpWishlistUrl,
        image: button.dataset.jpWishlistImage,
        vendor: button.dataset.jpWishlistVendor,
        price: button.dataset.jpWishlistPrice,
        compare: button.dataset.jpWishlistCompare
      });
      if (!product) return;
      items.unshift(product);
    }
    write(items); sync(items); renderPage(items);
    if (!exists) { button.classList.remove('jp-wishlist-pop'); void button.offsetWidth; button.classList.add('jp-wishlist-pop'); }
    announce((exists ? 'Removed ' : 'Added ') + (button.dataset.jpWishlistTitle || 'item') + (exists ? ' from' : ' to') + ' favorites');
  }
  function makeCard(p) {
    var article = document.createElement('article'); article.className = 'jp-wishlist-card';
    var mediaWrap = document.createElement('div'); mediaWrap.className = 'jp-wishlist-card__media-wrap';
    var media = document.createElement('a'); media.className = 'jp-wishlist-card__media'; media.href = p.url; media.setAttribute('aria-label', 'View ' + p.title);
    if (p.image) { var image = document.createElement('img'); image.src = p.image; image.alt = ''; image.loading = 'lazy'; image.width = 720; image.height = 720; media.appendChild(image); }
    var remove = document.createElement('button'); remove.type = 'button'; remove.className = 'jp-wishlist-card__remove'; remove.appendChild(removeIcon()); remove.setAttribute('aria-label', 'Remove ' + p.title + ' from favorites'); remove.setAttribute('title', 'Remove from favorites'); remove.dataset.jpRemoveWishlist = p.id;
    mediaWrap.appendChild(media); mediaWrap.appendChild(remove); article.appendChild(mediaWrap);
    if (p.vendor) { var vendor = document.createElement('div'); vendor.className = 'jp-wishlist-card__vendor'; vendor.textContent = p.vendor; article.appendChild(vendor); }
    var title = document.createElement('a'); title.className = 'jp-wishlist-card__title'; title.href = p.url; title.textContent = p.title; article.appendChild(title);
    if (p.price) { var price = document.createElement('div'); price.className = 'jp-wishlist-card__price'; price.textContent = p.price; if (p.compare) { var compare = document.createElement('span'); compare.className = 'jp-wishlist-card__compare'; compare.textContent = p.compare; price.appendChild(compare); } article.appendChild(price); }
    return article;
  }
  function renderPage(items) {
    var page = document.querySelector('[data-jp-wishlist-page]'); if (!page) return;
    var loading = page.querySelector('[data-jp-wishlist-loading]'), empty = page.querySelector('[data-jp-wishlist-empty]'), grid = page.querySelector('[data-jp-wishlist-grid]');
    if (!loading || !empty || !grid) return;
    loading.hidden = true; empty.hidden = items.length !== 0; grid.hidden = items.length === 0; grid.replaceChildren();
    items.forEach(function (p) { grid.appendChild(makeCard(p)); });
  }
  function announce(message) {
    document.querySelectorAll('[data-jp-wishlist-status]').forEach(function (status) {
      status.textContent = '';
      window.setTimeout(function () { status.textContent = message; }, 20);
    });
  }
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var button = target.closest('[data-jp-wishlist-button]');
    if (button) { event.preventDefault(); event.stopPropagation(); toggle(button); return; }
    var remove = target.closest('[data-jp-remove-wishlist]');
    if (remove) { event.preventDefault(); var items = read().filter(function (p) { return String(p.id) !== String(remove.dataset.jpRemoveWishlist); }); write(items); sync(items); renderPage(items); announce('Removed item from favorites'); }
  });
  document.addEventListener('DOMContentLoaded', function () { var items = read(); sync(items); renderPage(items); });
  window.addEventListener('pageshow', function () { var items = read(); sync(items); renderPage(items); });
  window.addEventListener('storage', function (event) { if (event.key === KEY) { var items = read(); sync(items); renderPage(items); } });
  document.addEventListener('shopify:section:load', function () { var items = read(); sync(items); renderPage(items); });
}());